import { useEffect } from "react";
import { useAccessStore } from "@/store/access.store";
import { usePlatformStore } from "@/store/platform.store";
import { usePlatformSessionStore } from "@/store/platformSession.store";
import { useSessionStore } from "@/store/session.store";

function SessionBootstrap() {
  useEffect(() => {
    const platform = usePlatformSessionStore.getState();
    if (!platform.ensureSessionValid()) {
      platform.signOut();
    }

    const session = useSessionStore.getState();
    if (!session.ensureSessionValid()) {
      session.signOut();
      return;
    }

    const user = session.user;
    if (!user) return;

    const modules =
      user.moduleToggles ??
      usePlatformStore.getState().getCustomer(user.systemCustomerId)?.modules;
    useAccessStore.getState().bindSessionAccess(
      user.role,
      user.companyIds ?? [],
      user.permissions ?? [],
      modules,
    );
  }, []);

  return null;
}

export { SessionBootstrap };
